export default __webpack_public_path__ + "static/media/collectionsApi.fec91c5b.svg";